module.exports = __webpack_public_path__ + "media/images/icons/flags/CD-1-3ccff29f451ff2999deeab5223bef756.svg";